import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_PBISMaintenance } from "../shared/data.service";
import { PBISPointItemUpdateRequest } from "../shared/PBISPointItemUpdateRequest";

@Component({
	selector: "app-point-maint-edit",
	templateUrl: "./point-maint-edit.component.html",
	styleUrls: ["./point-maint-edit.component.css"],
})
export class PointMaintEditComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_PBISMaintenance,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.PointsItemID = this.dialogConfig.data.PointsItemID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadPointsItem();
		// this.loadPointsCategoryType();
	}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////
	PointsItemID: any;
	SchoolID: any;

	MainData: any;
	LoadingMain: any = true;

	PointsItemDesc: any = "";

	PointsCategoryType: any;
	lstPointsCategoryType: any = [];

	PointsCategory: any;
	lstPointsCategory: any = [];

	PointsItemValue: any = 0;

	UseInClassroom: boolean = false;

	LoadingType: any = true;
	LoadingCategory: any = true;
	Processing: any = false;

	DisableClass: any = false;

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////
	loadPointsItem() {
		this.LoadingMain = true;

		var result = this.PBISService.PointsItemInfoGetList(this.PointsItemID);
		result.subscribe(
			(response) => {
				this.MainData = response[0];

				this.PointsItemDesc = this.MainData.PointsItemDesc;
				this.PointsItemValue = this.MainData.PointsItemValue;
				this.UseInClassroom = this.MainData.UseInClassRoom == 1 ? true : false;

				this.LoadingMain = false;

				this.loadPointsCategoryType();
			},
			(error) => {
				this.LoadingMain = false;
			}
		);
	}

	loadPointsCategoryType() {
		this.LoadingType = true;

		var result = this.PBISService.PBISPointsCategoryTypeGetList();
		result.subscribe(
			(response) => {
				this.lstPointsCategoryType = response;

				//this.PointsCategoryType = this.lstPointsCategoryType[0];
				for (var i = 0; i < this.lstPointsCategoryType.length; i++) {
					var next = this.lstPointsCategoryType[i];

					if (next.PointsCategoryTypeID == this.MainData.PointsCategoryTypeID) {
						this.PointsCategoryType = next;
						break;
					}
				}

				this.LoadingType = false;

				this.loadPointsCategory();
			},
			(error) => {
				this.LoadingType = false;
			}
		);
	}

	loadPointsCategory() {
		this.LoadingCategory = true;

		var result = this.PBISService.PBISPointsCategoryGetList(this.PointsCategoryType.PointsCategoryTypeID);
		result.subscribe(
			(response) => {
				this.lstPointsCategory = response;

				for (var i = 0; i < this.lstPointsCategory.length; i++) {
					var next = this.lstPointsCategory[i];

					if (next.PointsCategoryID == this.MainData.PointsCategoryID) {
						this.PointsCategory = next;
						break;
					}
				}

				if (this.PointsCategory.UseInClassRoom == 0) {
					this.UseInClassroom = false;
					this.DisableClass = true;
				}

				this.LoadingCategory = false;
			},
			(error) => {
				this.LoadingCategory = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////
	onAdd() {
		let parms: PBISPointItemUpdateRequest = {
			PointsItemID: this.PointsItemID,
			PointsItemDesc: this.PointsItemDesc,
			PointsItemValue: this.PointsItemValue,
			PointsCategoryID: this.PointsCategory.PointsCategoryID,
			UseInClassRoom: this.UseInClassroom == true ? 1 : 0,
		};

		var result = this.PBISService.PBISPointItemUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the point",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////
	onTypeChange(val) {
		this.PointsCategoryType = val;

		this.loadPointsCategory();
	}

	onCategoryChange(val) {
		this.PointsCategory = val;

		this.DisableClass = false;

		if (this.PointsCategory.UseInClassRoom == 0) {
			this.UseInClassroom = false;
			this.DisableClass = true;
		}
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingMain == true || this.LoadingType == true || this.LoadingCategory == true || this.Processing == true;
	}
	///////////////////////////////////////////////////////////////////////
}
